<template>
  <div class="quality-assurance">
    <div class="qa-table">
      <el-table
        border
        height="100%"
        :data="qualityList"
        ref="multipleTable"
        tooltip-effect="dark"
        header-row-class-name="customHeader"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="50">
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.rule')"
          align="left"
        >
          <template slot-scope="{ row }">
            <template v-if="row.code === 'QA-T13' || row.code === 'QA-T14'">
              {{ $i18n.locale === 'zh' ? row.description.split('{percent}')[0] : row.nameEn.split('{percent}')[0] }}<el-input-number size="small" v-model="row.wordPercent" controls-position="right" :min="1" :max="100">
                </el-input-number>{{ $i18n.locale === 'zh' ? row.description.split('{percent}')[1] : row.nameEn.split('{percent}')[1] }}
            </template>
            <template v-else>
              {{ $i18n.locale === 'zh' ? row.description : row.nameEn }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.severeLevel')"
          align="center"
          width="400"
        >
          <template slot-scope="{ row }">
            <el-select style="width:120px" v-model="row.grade" size="small">
              <el-option
                v-for="(item, index) in severeLevelList"
                :key="index"
                :label="item.desc"
                :value="item.level"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="qa-bottom">
      <el-checkbox v-model="openQA" @change="handleOpenQA">{{$t('newProjectV2.openQa')}}</el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QualityAssurance',
  props: {
    openQa: {
      type: Boolean,
      default () {
        return true
      }
    },
    qualityList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      tableHight: '100%',
      openQA: this.openQa,
      severeLevelList: [{
        level: 0,
        desc: this.$t('newProjectV2.slightError')
      }, {
        level: 1,
        desc: this.$t('newProjectV2.generalError')
      }, {
        level: 2,
        desc: this.$t('newProjectV2.seriousError')
      }]
    }
  },
  methods: {
    handleSelectionChange (selection) {
      let selID = [];
      selection.forEach(item => {
        selID.push(item.id);
      });
      this.$emit('selAualityIDChange', selID);
    },
    handleOpenQA (newVal) {
      this.$emit('handleOpenQA', newVal);
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>